"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.neo = exports.decodeNeoAddress = exports.encodeNeoAddress = void 0;
const base58_js_1 = require("../utils/base58.js");
const name = "neo";
const coinType = 239;
exports.encodeNeoAddress = base58_js_1.base58CheckEncode;
exports.decodeNeoAddress = base58_js_1.base58CheckDecode;
exports.neo = {
    name,
    coinType,
    encode: exports.encodeNeoAddress,
    decode: exports.decodeNeoAddress,
};
//# sourceMappingURL=neo.js.map